import { httpClient } from '../httpClient';
import {
  IProject,
  CreateProjectRequest,
  UpdateProjectRequest,
  PaginatedResponse,
  ProjectQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户剧集 API 模块
 * 处理用户剧集创作操作
 */
export class ProjectApi {

  /**
   * 获取剧集详情
   */
  async getProject(id: string): Promise<IProject> {
    return httpClient.get<IProject>(`/user/projects/${id}`);
  }

  /**
   * 获取用户剧集分页列表（POST，强类型）
   */
  async projectPageList(queryData: PaginationQuery<ProjectQuery>): Promise<PaginatedResponse<IProject>> {
    return httpClient.post<PaginatedResponse<IProject>>('/user/projects/page', queryData);
  }

  /**
   * 创建剧集
   */
  async createProject(data: CreateProjectRequest): Promise<IProject> {
    return httpClient.post<IProject>('/user/projects', data);
  }

  /**
   * 更新剧集
   */
  async updateProject(id: string, data: UpdateProjectRequest): Promise<IProject> {
    return httpClient.put<IProject>(`/user/projects/${id}`, data);
  }

  /**
   * 删除剧集
   */
  async deleteProject(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/projects/${id}`);
  }

}

// 导出单例实例
export const projectApi = new ProjectApi();